import * as React from "react";
import { useState, useEffect } from "react";
import { atom, useSetRecoilState, useRecoilValue } from "recoil";
import qs from "qs";
import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/firestore";
import {
  FirebaseAuthProvider,
  FirebaseAuthConsumer,
  //IfFirebaseAuthed,
  //IfFirebaseAuthedAnd
} from "@react-firebase/auth";
import { useWaxUser, WaxAuth } from "./wax-auth";
import { CheckSteps } from "./check-steps";
import "./style.css";

function isEmail(email) {
  let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

export class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      emailLogin: "",
      passwordLogin: "",
      errorMessage: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleLogin(event) {
    event.preventDefault();

    firebase
      .auth()
      .signInWithEmailAndPassword(
        this.state.emailLogin,
        this.state.passwordLogin
      )
      .then((userCredential) => {
        // Signed in
        //let user = userCredential.user;
        //console.log('Logged-in: ' + user.email);

        firebase.analytics().logEvent("logins", {
          method: "Web",
        });
      })
      .catch((error) => {
        //let errorCode = error.code;
        let errorMessage = error.message;
        this.setState({
          errorMessage: "" + errorMessage,
        });
      });
  }

  render() {
    return (
      <div className="popup" id="popup-login">
        <div className="popup-inner">
          <div className="popupphoto">
            <img src="img/bong.png" />
          </div>
          <div className="popuptext popup-form-text">
            <div className="login-container">
              <div className="row">
                <div className="left">
                  <h1>LOGIN</h1>
                </div>
                <div className="right">
                  <a className="signuptext" href="#popup-register">
                    I don't have an account
                  </a>
                </div>

                <div className="contact-form">
                  <div id="errormessage-login" className="errormsg"></div>
                  <form id="login-form" role="form" onSubmit={this.handleLogin}>
                    <div className="col-md-12 popupform">
                      <div className="popupform-email">
                        <p>Email</p>
                      </div>
                      <input
                        id="email-login"
                        name="emailLogin"
                        type="email"
                        className="form-control popupform"
                        placeholder="Enter your account email"
                        required
                        data-msg="Email is required"
                        value={this.state.emailLogin}
                        onChange={this.handleInputChange}
                      />
                      <div className="validation"></div>
                      <div className="popupform-email">
                        <p>Password</p>
                      </div>
                      <input
                        id="password-login"
                        name="passwordLogin"
                        type="password"
                        className="form-control popupform"
                        placeholder="Enter your account password"
                        required
                        data-msg="Password is required"
                        value={this.state.passwordLogin}
                        onChange={this.handleInputChange}
                      />
                      <div className="validation">
                        {this.state.errorMessage}
                      </div>
                      <div>
                        <a href="#popup-reset" className="forgotpw">
                          Forgot Password ?
                        </a>
                      </div>
                      <button type="submit" className="popup-login popupcenter">
                        Login
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
           
            <a className="closepopup" href="#">
              X
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export class RegistrationForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      didAccept: false,
      emailReg: "",
      passwordReg: "",
      errorMessage: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleReg = this.handleReg.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleReg(event) {
    //console.log("handleNewUser: " + this.state.emailReg);

    event.preventDefault();

    if (!this.state.didAccept) {
      this.setState({
        errorMessage:
          "Please check the box to accept to be contacted by email.",
      });
    } else if (this.state.emailReg == "" || !isEmail(this.state.emailReg)) {
      this.setState({
        errorMessage: "Please specify a valid email address.",
      });
    } else if (
      this.state.passwordReg == "" ||
      this.state.passwordReg.length < 6
    ) {
      this.setState({
        errorMessage:
          "Please specify a password that is at least 6 characters in length.",
      });
    } else {
      firebase
        .auth()
        .createUserWithEmailAndPassword(
          this.state.emailReg,
          this.state.passwordReg
        )
        .then((userCredential) => {
          // Signed in
          //let user = userCredential.user;
          firebase.analytics().logEvent("sign_up", {
            method: "Web",
          });
        })
        .catch((error) => {
          //let errorCode = error.code;
          let errorMessage = error.message;
          this.setState({
            errorMessage: "" + errorMessage,
          });
        });
    }
  }

  render() {
    return (
      <div className="popup" id="popup-register">
        <div className="popup-inner">
          <div className="popupphoto">
            <img src="img/Hal.png" />
          </div>
          <div className="popuptext popup-form-text">
            <div className="login-container">
              <div className="row">
                <div className="left">
                  <h1>REGISTER</h1>
                </div>
                <div className="right">
                  <a className="signuptext" href="#popup-login">
                    Login
                  </a>
                </div>
                <div className="contact-form">
                  <div id="errormessage-register" className="errormsg"></div>
                  <form
                    id="register-form"
                    role="form"
                    onSubmit={this.handleReg}
                  >
                    <div className="col-md-12 popupform">
                      <div className="popupform-email">
                        <p>Email</p>
                      </div>
                      <input
                        name="emailReg"
                        type="email"
                        className="form-control popupform"
                        id="email-register"
                        placeholder="Enter your account email"
                        required
                        data-msg="Email is required"
                        value={this.state.emailReg}
                        onChange={this.handleInputChange}
                      />
                      <div className="validation"></div>
                      <div className="popupform-email">
                        <p>Password</p>
                      </div>
                      <input
                        type="password"
                        name="passwordReg"
                        className="form-control popupform"
                        id="password-register"
                        placeholder="Minimum 6 characters"
                        required
                        data-msg="Password is required"
                        value={this.state.passwordReg}
                        onChange={this.handleInputChange}
                      />
                      <div className="validation">
                        {this.state.errorMessage}
                      </div>
                      <div className="popup-checkbox">
                        <input
                          type="checkbox"
                          id="tos-register"
                          name="didAccept"
                          value="tos-register"
                          checked={this.state.didAccept}
                          onChange={this.handleInputChange}
                        />
                        <label for="tos-register" className="form-checkbox">
                          {" "}
                          I agree to be contacted by email for the purpose of
                          receiving updates about this game.
                        </label>
                      </div>
                      <div className="popup-disclaimer-text">
                        <p>
                          By selecting "Register" I agree to the{" "}
                          <a href="https://service-terms.eastsidegames.com/">
                            Terms of Service
                          </a>{" "}
                          and{" "}
                          <a href="https://privacy-policy.eastsidegames.com/">
                            Privacy Policy
                          </a>
                        </p>
                      </div>
                      <div>
                        <button type="submit" className="popup-login btnright">
                          Register
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            
            <a className="closepopup" href="#">
              X
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export class SendEmailLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      emailLink: "",
      errorMessage: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleLink = this.handleLink.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleLink(event) {
    //console.log("SendEmailLink: " + this.state.emailLink);

    event.preventDefault();

    if (this.state.emailLink == "" || !isEmail(this.state.emailLink)) {
      this.setState({
        errorMessage: "Please specify a valid email address.",
      });
    } else {
      firebase
        .auth()
        .sendPasswordResetEmail(this.state.emailLink)
        .then((resp) => {
          this.props.alertHandler("Reset link sent!");
        })
        .catch(function (error) {
          let errorCode = error.code;
          let errorMessage = error.message;
          this.setState({
            errorMessage: "" + errorMessage,
          });
        });
    }
  }

  render() {
    return (
      <div className="popup" id="popup-reset">
        <div className="popup-inner">
          <div className="popupphoto">
            <img src="img/cow.png" />
          </div>
          <div className="popuptext popup-form-text">
            <div className="login-container">
              <div className="row">
                <div className="contact-form">
                  <div id="errormessage-reset" className="errormsg"></div>
                  <form
                    id="reset-link-form"
                    role="form"
                    onSubmit={this.handleLink}
                  >
                    <div className="col-md-12 popupform">
                      <div className="popupform-email">
                        <p>Enter your email to get a reset link</p>
                      </div>
                      <input
                        name="emailLink"
                        type="email"
                        className="form-control popupform"
                        id="email-reset"
                        placeholder="Enter your account email"
                        required
                        data-msg="Email is required"
                        value={this.state.emailLink}
                        onChange={this.handleInputChange}
                      />
                      <div className="validation"></div>
                      <button type="submit" className="popup-login popupcenter">
                        Get Reset Link
                      </button>
                      <div className="orlogin-text">
                        <a href="#popup-login">Or Login</a>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <a className="close-back" href="#">
              &#60;
            </a>
            <a className="closepopup" href="#">
              X
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export class ResetPasswordForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      emailReset: "",
      passwordReset: "",
      errorMessage: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleReset(event) {
    //console.log("handleReset: " + this.props.email);

    event.preventDefault();

    if (this.state.passwordReset == "" || this.state.passwordReset.length < 6) {
      this.setState({
        errorMessage:
          "Please specify a password that is at least 6 characters in length.",
      });
    } else {
      // Save the new password.
      firebase
        .auth()
        .confirmPasswordReset(this.props.actionCode, this.state.passwordReset)
        .then((resp) => {
          this.props.alertHandler("Password reset!");
        })
        .catch((error) => {
          let errorCode = error.code;
          let errorMessage = error.message;
          this.setState({
            errorMessage: "" + errorMessage,
          });
          console.log("Confirm reset error: " + errorMessage);
        });
    }
  }

  render() {
    return (
      <div className="popup" id="popup-resetpassword">
        <div className="popup-inner">
          <div className="popupphoto">
            <img src="img/Hal.png" />
          </div>
          <div className="popuptext popup-form-text">
            <div className="login-container">
              <div className="row">
                <div className="left">
                  <h1>RESET PASSWORD</h1>
                </div>
                <div className="right">
                  <a className="signuptext" href="#popup-login">
                    Login
                  </a>
                </div>
                <div className="contact-form">
                  <div id="errormessage-reset" className="errormsg"></div>
                  <form id="reset-form" role="form" onSubmit={this.handleReset}>
                    <div className="col-md-12 popupform">
                      <div className="popupform-email">
                        <p>Email: </p>
                        {this.props.email}
                      </div>
                      <div className="validation"></div>
                      <div className="popupform-email">
                        <p>Password</p>
                      </div>
                      <input
                        type="password"
                        name="passwordReset"
                        className="form-control popupform"
                        id="password-reset"
                        placeholder="Minimum 6 characters"
                        required
                        data-msg="Password is required"
                        value={this.state.passwordReset}
                        onChange={this.handleInputChange}
                      />
                      <div className="validation">
                        {this.state.errorMessage}
                      </div>
                      <div>
                        <button type="submit" className="popup-login btnright">
                          Reset
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <a className="close-back" href="#">
              &#60;
            </a>
            <a className="closepopup" href="#">
              X
            </a>
          </div>
        </div>
      </div>
    );
  }
}
export class EmailPopUpVerify extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      errorMessage: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
   
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
 
  
  render() {
  return (
      <div className="popup" id="emailPopUpVerify">
        <div className="popup-inner">
          <div className="popupphoto">
            <img src="img/Hal.png" />
          </div>
          <div className="popuptext popup-form-text">
            <div className="login-container">
              <div className="row">
                <div className="left">
                  <h1>Email Verified</h1>
                </div>
                <div className="right">
                  <h2 className="signuptext" >
                    Congrats! Your Email Is Verified
                  </h2>
                  <div className="validation">{this.state.errorMessage}</div>
                </div>

           
            <a className="closepopup" href="#">
              X
            </a>
            </div>
            </div>
         </div>
        </div>
      </div>
  );
  }
}

export class AlertBox extends React.Component {
  constructor(props) {
    super(props);

    this.handleOkay = this.handleOkay.bind(this);
  }

  handleOkay(event) {
    //console.log("handleOkay");

    event.preventDefault();
    window.location.href = "/";
  }

  render() {
    return (
      <div className="popup" id="popup-alert">
        <div className="popup-inner">
          <div className="popupphoto">
            <img src="img/Hal.png" />
          </div>
          <div className="popuptext popup-form-text">
            <div className="login-container">
              <div className="row">
                <div className="left">
                  <h1>INFO</h1>
                </div>
                <div className="contact-form">
                  <div id="errormessage-alert" className="errormsg"></div>
                  <form id="alert-form" role="form" onSubmit={this.handleOkay}>
                    <div className="col-md-12 popupform">
                      <div className="popupform-email">
                        <p>{this.props.message}</p>
                      </div>
                      <div>
                        <button type="submit" className="popup-login btnright">
                          Okay
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
           
            <a className="closepopup" href="#">
              X
            </a>
          </div>
        </div>
      </div>
    );
  }
}

// This is a Recoil atom (https://recoiljs.org/docs/api-reference/core/atom)
// You can think of it as a unique reactive node with our current users state.
// Our hook is going to subscribe to this state.
export const $firebaseUser = atom({
  key: "FIREBASE::USER", // Atoms needs a unique key, we can only ever call the atom function once with this key.
  default: null,
});

export const $firebaseToken = atom({
  key: "FIREBASE::TOKEN", // Atoms needs a unique key, we can only ever call the atom function once with this key.
  default: null,
});

export const $firebaseUID = atom({
  key: "FIREBASE::UID", // Atoms needs a unique key, we can only ever call the atom function once with this key.
  default: null,
});

export const $firebaseAuthd = atom({
  key: "FIREBASE::AUTHD", // Atoms needs a unique key, we can only ever call the atom function once with this key.
  default: false,
});

export const $firebaseWallet = atom({
  key: "FIREBASE::WALLET", // Atoms needs a unique key, we can only ever call the atom function once with this key.
  default: false,
});

// Our actual hook
export function useFirebaseUser() {
  const currentFirebaseUser = useRecoilValue($firebaseUser);
  const token = useRecoilValue($firebaseToken);
  const uid = useRecoilValue($firebaseUID);
  const hasWallet = useRecoilValue($firebaseWallet);
  const authd = useRecoilValue($firebaseAuthd);

  return {
    email: currentFirebaseUser,
    accessToken: token,
    uid: uid,
    hasWallet: hasWallet,
    didAuth: authd,
  };
}

// TODO: Replace the following with your app's Firebase project configuration
// For Firebase JavaScript SDK v7.20.0 and later, `measurementId` is an optional field
const config = {
  apiKey: "AIzaSyBWziPWyI6m67eSy0Q6bKHJ-mSyAt8hNKQ",
  authDomain: "leaf-auth.firebaseapp.com",
  projectId: "leaf-auth",
  storageBucket: "leaf-auth.appspot.com",
  messagingSenderId: "624769186762",
  appId: "1:624769186762:web:a3ebbb65d0228bed296d33",
  measurementId: "G-787BSXM848",
};

export function FirebaseAuth() {
  const setFirebaseUser = useSetRecoilState($firebaseUser);
  const setAccessToken = useSetRecoilState($firebaseToken);
  const setUID = useSetRecoilState($firebaseUID);
  const setHasWallet = useSetRecoilState($firebaseWallet);
  const setAuth = useSetRecoilState($firebaseAuthd);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [didSaveWax, setDidSaveWax] = useState(false);
  const [resetCode, setResetCode] = useState(null);
  const [resetEmail, setResetEmail] = useState("");
  const [didReset, setDidReset] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [savedWalletName, setSavedWalletName] = useState("");

  const waxUser = useWaxUser();

  const showAlert = function (msg) {
    setAlertMsg(msg);
    window.location.href = "#popup-alert";
  };

  function checkWaxInfo(uid) {
    // check if doc exists
    firebase
      .firestore()
      .collection("wax")
      .doc(uid)
      .get()
      .then((doc) => {
        if (doc.exists) {
          let data = doc.data();
          if (data["waxwallet"] != "" && data["waxwallet"] != null) {
            setSavedWalletName(data["waxwallet"]);
            setHasWallet(true);
          }
        }
      })
      .catch((error) => {
        console.log("Error getting Wax document:", error);
      });
  }

  function saveWaxInfo(uid, displayName, userEmail, waxAccount, waxKeys) {
    if (!uid || uid == "") return;
    if (!waxAccount) return;

    if (didSaveWax) return;
    setDidSaveWax(true);

    setSavedWalletName(waxAccount);
    setHasWallet(true);

    //console.log("Saving WAX Wallet Info.");

    let info = {
      name: displayName == null ? "None" : displayName,
      email: email == null ? "None" : userEmail,
      waxwallet: waxAccount,
      waxkeys: waxKeys,
      updated: firebase.firestore.Timestamp.now(),
    };

    // check if doc exists
    firebase
      .firestore()
      .collection("wax")
      .doc(uid)
      .get()
      .then((doc) => {
        if (doc.exists) {
          // new Wax update
          console.log("Wallet_update");
          firebase.analytics().logEvent("wax_wallet_update");
        } else {
          // new Wax wallet
          console.log("Wallet_new");
          firebase.analytics().logEvent("wax_wallet_new");
        }

        // Add or update wax info
        firebase
          .firestore()
          .collection("wax")
          .doc(uid)
          .set(info)
          .then(() => {
            console.log("Wax document successfully written!");
          })
          .catch((error) => {
            console.error("Error writing Wax document: ", error);
          });
      })
      .catch((error) => {
        console.log("Error getting Wax document:", error);
      });
  }

  useEffect(() => {
    const v = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    if (!didReset && v.mode && v.mode == "resetPassword") {
      setDidReset(true);

      let actionCode = v.oobCode;
      setResetCode(actionCode);

      // Verify the password reset code is valid.
      firebase
        .auth()
        .verifyPasswordResetCode(actionCode)
        .then((email) => {
          let accountEmail = email;
          setResetEmail(accountEmail);

          window.location.href = "#popup-resetpassword";
        })
        .catch((error) => {
          console.log("Error on reset:", error);
        });
    }

    if (!didReset && v.mode && v.mode == "verifyEmail") {
      setDidReset(true);
      let actionCode = v.oobCode;
      firebase.auth().applyActionCode(actionCode)
      .then((resp) => {   
        window.location.href = "#emailPopUpVerify";
      })
      .catch((error) => {
        setAlertMsg("oh no! we can't verify the link");
        console.log("this is the error:", error);
        window.location.href = "#popup-alert"
      })
    }
  });

  return (
    <div>
      <nav id="nav">
        <ul id="page-nav">
          <li>
            <a href="#home">Home</a>
          </li>
          <li>
            <a href="#about">About</a>
          </li>
          <li>
            <a href="#leadersection">Leaderboard</a>
          </li>
          <li>
            <a href="#leadersection">Prizes</a>
          </li>
          <li>
            <a href="#faq">FAQ</a>
          </li>
          <li>
            <a href="#footer">Contact</a>
          </li>
        </ul>

        <CheckSteps />

        {/*   		
		<ul id="social-support">
				<a href="#"><img src="img/tw.png" alt="Twitter"></a>
				<a href="#"><img src="img/ig.png" alt="Instagram"></a>
				<a href="#"><img src="img/fb.png" alt="Facebook"></a>
  		</ul>
	  	*/}

        <div id="navbtn">
          <FirebaseAuthProvider {...config} firebase={firebase}>
            <FirebaseAuthConsumer>
              {({ isSignedIn, user, providerId }) => {
                if (isSignedIn === true) {
                  setFirebaseUser(user.email);
                  setUID(user.uid);
                  user
                    .getIdToken()
                    .then(function (idToken) {
                      setAccessToken(idToken);
                    })
                    .catch(function (error) {
                      console.log("Firebase access token error.");
                    });
                  setAuth(true);

                  checkWaxInfo(user.uid);

                  if (waxUser.didAuth) {
                    saveWaxInfo(
                      user.uid,
                      user.displayName,
                      user.email,
                      waxUser.account,
                      waxUser.pubKeys
                    );
                  }

                  if (savedWalletName != "") {
                    return (
                      <>
                        <div className="emailaddr">
                          <p>
                            {user.email}&nbsp;<span>[{savedWalletName}]</span>
                          </p>
                          <a href="#popup-login">
                            <button
                              className="signoutbtn"
                              href="#"
                              onClick={() => {
                                firebase.auth().signOut();
                              }}
                            >
                              SIGN OUT
                            </button>
                          </a>
                        </div>
                        <WaxAuth />
                      </>
                    );
                  } else {
                    return (
                      <>
                        <div className="emailaddr">
                          <p>{user.email}</p>
                          <a href="#popup-login">
                            <button
                              className="signoutbtn"
                              href="#"
                              onClick={() => {
                                firebase.auth().signOut();
                              }}
                            >
                              SIGN OUT
                            </button>
                          </a>
                        </div>
                        <WaxAuth />
                      </>
                    );
                  }
                } else {
                  setFirebaseUser(null);
                  setAccessToken(null);
                  setAuth(false);
                  return (
                    <div>
                      <a
                        id="login-register"
                        className="popuplink"
                        href="#popup-register"
                      >
                        <button class="banner-button nav navbar-nav navbar-right">
                          REGISTER
                        </button>
                      </a>
                      <a
                        id="login-register"
                        className="popuplink"
                        href="#popup-login"
                      >
                        <button class="banner-button nav navbar-nav navbar-right">
                          LOGIN
                        </button>
                      </a>

                      <RegistrationForm />
                      <LoginForm />
                      <SendEmailLink alertHandler={showAlert} />
                      <EmailPopUpVerify/>
                      <ResetPasswordForm
                        actionCode={resetCode}
                        email={resetEmail}
                        alertHandler={showAlert}
                      />
                      {/* <EmailHandler/> */}
                      <AlertBox message={alertMsg} />
                    </div>
                  );
                }
              }}
            </FirebaseAuthConsumer>
          </FirebaseAuthProvider>
        </div>
      </nav>
    </div>
  );
}
